<template>
  <svg
    :class="[size, color]"
    class="animate-spin"
    fill="none"
    viewBox="0 0 24 24"
  >
    <circle
      cx="12"
      cy="12"
      r="10"
      stroke="currentColor"
      stroke-width="1"
      stroke-opacity="0.25"
    ></circle>
    <path
      stroke="currentColor"
      stroke-width="1"
      stroke-opacity="0.75"
      d="M12 2a10 10 0 0 1 10 10"
    ></path>
  </svg>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    size?: string;
    color?: string;
  }>(),
  {
    size: "h-8 w-8",
    color: "text-gray-400",
  },
);
</script>
